// extracted by mini-css-extract-plugin
export default {"root":"styles_root__qKBZZ","header":"styles_header__w7W5l","content":"styles_content__nodCf","footer":"styles_footer__YXi5F"};